import React, { Fragment } from 'react';
import { Login, LoginForm } from 'ra-ui-materialui';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  main: {
    backgroundImage: 'none !important',
  },
};

const CustomLogin = props => (
  <Fragment>
    <span>.</span>
    <Login loginForm={<LoginForm />} {...props} />
  </Fragment>
);

export default withStyles(styles)(CustomLogin);



// WEBPACK FOOTER //
// ./src/components/Login/index.js